import { render, staticRenderFns } from "./UserCenterSideMenuGroup.vue?vue&type=template&id=6c3289e3&scoped=true"
import script from "./UserCenterSideMenuGroup.vue?vue&type=script&lang=js"
export * from "./UserCenterSideMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./UserCenterSideMenuGroup.vue?vue&type=style&index=0&id=6c3289e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3289e3",
  null
  
)

export default component.exports